// Generated from the API's controllers by MiningwareApi.Tests/WriteVocabularyTests.cs - do not edit.
// Run `UPDATE_WRITE_VOCABULARY=1 dotnet test MiningwareApi.Tests --filter WriteVocabularyTests` after changing a controller's writes.
import { AreaKey } from "./pageVocabulary.generated";

/** Every write behind a page, as Controller.Method. The server says which of them a user may make. */
export const WRITE_KEYS = [
  "BlastFiring.ClearMisfire",
  "BlastFiring.RemoveFragmentation",
  "BlastFiring.RemoveSentry",
  "BlastFiring.ReportMisfire",
  "BlastFiring.SaveFiring",
  "BlastFiring.SaveFragmentation",
  "BlastFiring.SaveReading",
  "BlastFiring.SaveSentry",
  "BlastHoles.AddAttempt",
  "BlastHoles.AddDip",
  "BlastHoles.AddHole",
  "BlastHoles.CloseWorkSheet",
  "BlastHoles.DeleteAttempt",
  "BlastHoles.DeleteDip",
  "BlastHoles.ImportDesign",
  "BlastHoles.ImportIredesQuality",
  "BlastHoles.IssueWorkSheet",
  "BlastHoles.SaveCharge",
  "BlastHoles.SetEntryMode",
  "BlastHoles.UpdateAttempt",
  "BlastHoles.UpdateDip",
  "BlastMonitors.AddLimit",
  "BlastMonitors.AddMonitor",
  "BlastMonitors.UpdateLimit",
  "BlastMonitors.UpdateMonitor",
  "BlastPattern.MoveStatus",
  "BlastPattern.SaveDesign",
  "Blasts.AddBlastPattern",
  "Blasts.AddMaterial",
  "Blasts.AddMaterialType",
  "Blasts.DeleteBlastPattern",
  "Blasts.DeleteMaterial",
  "Blasts.DeleteMaterialType",
  "Blasts.UpdateBlastPattern",
  "Blasts.UpdateBlastPatternGeofence",
  "Blasts.UpdateMaterial",
  "Blasts.UpdateMaterialRegisterDetails",
  "Blasts.UpdateMaterialType",
  "Blasts.UpdateMaterialUsage",
  "Consumables.AddItem",
  "Consumables.AddStore",
  "Consumables.ApproveStocktake",
  "Consumables.CancelStocktake",
  "Consumables.DiscardParked",
  "Consumables.Fit",
  "Consumables.PostBulkIssue",
  "Consumables.PostParked",
  "Consumables.PostTransaction",
  "Consumables.Remove",
  "Consumables.ReturnFromRegrind",
  "Consumables.ReverseTransaction",
  "Consumables.SaveStockLevel",
  "Consumables.SubmitStocktake",
  "Consumables.UpdateItem",
  "Consumables.UpdateStore",
  "Dewatering.AddDewatering",
  "Dewatering.DeleteDewatering",
  "Dewatering.UpdateDewatering",
  "Digging.CopyTruckLoadsFromPreviousHour",
  "Digging.DeleteDiggingPattern",
  "Digging.DeleteTruckLoad",
  "Digging.InsertDiggingLocation",
  "Digging.InsertTruckLoad",
  "Digging.MoveLoadingRecord",
  "Digging.UpdateDiggingLocation",
  "Digging.UpdateTruckLoad",
  "Digging.VerifyTruckLoads",
  "DrillBlastReference.AddBitSize",
  "DrillBlastReference.AddBlastType",
  "DrillBlastReference.AddHoleType",
  "DrillBlastReference.AddRemovalReason",
  "DrillBlastReference.UpdateBitSize",
  "DrillBlastReference.UpdateBlastType",
  "DrillBlastReference.UpdateHoleType",
  "DrillBlastReference.UpdateRemovalReason",
  "DrillBlastSettings.AddControlPoint",
  "DrillBlastSettings.BulkClose",
  "DrillBlastSettings.DeleteControlPoint",
  "DrillBlastSettings.SetPolicy",
  "DrillBlastSettings.SetSetting",
  "DrillBlastSettings.UpdateControlPoint",
  "Drilling.AddBlastHole",
  "Drilling.AddBlastPattern",
  "Drilling.CreateDrilling",
  "Drilling.DeleteBlastHole",
  "Drilling.RemoveBlastPatternFromDrilling",
  "Drilling.UpdateBlastHole",
  "Explosives.ApproveStocktake",
  "Explosives.CancelStocktake",
  "Explosives.DiscardParked",
  "Explosives.Post",
  "Explosives.PostParked",
  "Explosives.Reverse",
  "Explosives.SignOffVariance",
  "Explosives.SubmitStocktake",
  "GcDrilling.AddLine",
  "GcDrilling.CreateSession",
  "GcDrilling.DeleteLine",
  "GcDrilling.UpdateLine",
  "Geology.DeleteFilterFromMiningMovement",
  "Geology.DeleteGeoDrilling",
  "Geology.DeleteGeoDrillingEntry",
  "Geology.DeleteGeoMill",
  "Geology.DeleteGeoOreTruck",
  "Geology.DeleteGeologyMiningMovement",
  "Geology.DeleteGeologyOreBlock",
  "Geology.DeleteGeologyRehandle",
  "Geology.DeleteGeologyRehandleGroup",
  "Geology.InsertGeoMill",
  "Geology.InsertGeologyMiningMovement",
  "Geology.InsertGeologyOreBlock",
  "Geology.InsertGeologyProductionEntry",
  "Geology.InsertGeologyProductionMiningMovement",
  "Geology.InsertGeologyRehandle",
  "Geology.InsertOrUpdateGeoDrilling",
  "Geology.InsertOrUpdateGeoOreBlock",
  "Geology.InsertOrUpdateGeoOreTruck",
  "Geology.RecalculateStockpileBalances",
  "Geology.SaveGeoDrillingEntry",
  "Geology.UpdateGeoDrilling",
  "Geology.UpdateGeoMill",
  "Geology.UpdateGeoOreTruck",
  "Geology.UpdateGeologyMiningMovement",
  "Geology.UpdateGeologyOreBlock",
  "Geology.UpdateGeologyOreBlockGeofence",
  "Geology.UpdateGeologyOreTallyMiningProductionEntry",
  "Geology.UpdateGeologyProductionEntry",
  "Geology.UpdateGeologyRehandle",
  "Geology.VerifyAllGeoRehandles",
  "Geology.VerifyGeoRehandle",
  "Geology.VerifyGeologyRehandleGroup",
  "GeologyStockpile.ApplyStockpileAdjustment",
  "GeologyStockpile.ApplyStockpileBlockAdjustments",
  "GeologyStockpile.UpdateDetailAnalytes",
  "Magazines.AddMagazine",
  "Magazines.UpdateMagazine",
  "Operations.CompleteShiftAsync",
  "Operations.UpdateEngineHours",
  "Operations.UpdateOperationLocation",
  "Personnel.AddLicence",
  "Personnel.AddPerson",
  "Personnel.DeleteLicence",
  "Personnel.UpdateLicence",
  "Personnel.UpdatePerson",
  "Plant.DeletePlantType",
  "Plant.InsertPlantType",
  "Plant.UpdatePlantType",
  "References.DeleteAnalyte",
  "References.DeleteBucketFactor",
  "References.DeleteBucketType",
  "References.DeleteDensity",
  "References.DeleteLocation",
  "References.DeleteMaterialType",
  "References.DeleteMaterialTypeClass",
  "References.DeletePitStage",
  "References.DeletePlant",
  "References.DeletePlantBucket",
  "References.DeleteZone",
  "References.InsertAnalyte",
  "References.InsertBucketFactor",
  "References.InsertBucketType",
  "References.InsertDensity",
  "References.InsertLocation",
  "References.InsertMaterialType",
  "References.InsertMaterialTypeClass",
  "References.InsertPitStage",
  "References.InsertPlant",
  "References.InsertPlantBucket",
  "References.InsertZone",
  "References.UpdateAnalyte",
  "References.UpdateBucketFactor",
  "References.UpdateBucketType",
  "References.UpdateDensity",
  "References.UpdateLocation",
  "References.UpdateLocationGeofence",
  "References.UpdateMaterialType",
  "References.UpdateMaterialTypeClass",
  "References.UpdatePitStage",
  "References.UpdatePlant",
  "References.UpdatePlantBucket",
  "References.UpdateZone",
  "ReportComments.Save",
  "ReportDefinitions.Create",
  "ReportDefinitions.Delete",
  "ReportDefinitions.DesignerChat",
  "ReportDefinitions.GenerateCommentary",
  "ReportDefinitions.LogRun",
  "ReportDefinitions.Rename",
  "ReportDefinitions.SaveDesignSession",
  "ReportDefinitions.SendFeedback",
  "ReportDefinitions.Update",
  "RigMeters.RecordService",
  "RigMeters.SaveOperationMeter",
  "RigMeters.SavePlantMeters",
  "RoyaltySplits.DeleteChatreeRoyaltyArea",
  "RoyaltySplits.DeleteChatreeRoyaltyAreaBlastMaster",
  "RoyaltySplits.ImportChatreeRoyaltyAreaBlastMasters",
  "RoyaltySplits.InsertChatreeRoyaltyArea",
  "RoyaltySplits.InsertChatreeRoyaltyAreaBlastMaster",
  "RoyaltySplits.UpdateChatreeRoyaltyArea",
  "RoyaltySplits.UpdateChatreeRoyaltyAreaBlastMaster",
  "Stoppages.CheckGpsStoppage",
  "Stoppages.CreateMultipleStoppages",
  "Stoppages.DeleteImage",
  "Stoppages.DeleteStoppage",
  "Stoppages.DeleteStoppageSubType",
  "Stoppages.InsertStoppage",
  "Stoppages.InsertStoppageSubType",
  "Stoppages.UpdateStoppage",
  "Stoppages.UpdateStoppageSubType",
  "Stoppages.UploadImage",
  "TargetImport.Analyze",
  "TargetImport.CreateTemplate",
  "TargetImport.DeleteTemplate",
  "TargetImport.Execute",
  "TargetImport.GetSheets",
  "TargetImport.Preview",
  "TargetImport.ResolveLabels",
  "TargetImport.UpdateTemplate",
  "Targets.AddTarget",
  "Targets.AddTargetType",
  "Targets.AddTargetsForAllTargetTypes",
  "Targets.DeleteTarget",
  "Targets.DeleteTargetType",
  "Targets.SetTargetBasis",
  "Targets.SetTargetsCard",
  "Targets.UpdateTarget",
  "Targets.UpdateTargetType",
  "Telemetry.DeleteDeviceMapping",
  "Telemetry.DeleteVendorStoppageCodeMapping",
  "Telemetry.InsertDeviceMapping",
  "Telemetry.InsertVendorStoppageCodeMapping",
  "Telemetry.UpdateDeviceMapping",
  "Telemetry.UpdateVendorStoppageCodeMapping",
  "Telemetry.Upload",
] as const;

export type WriteKey = (typeof WRITE_KEYS)[number];

/** The pages with a write behind them, which are the only pages a user can be view only on. */
export const AREAS_WITH_WRITES: ReadonlySet<AreaKey> = new Set<AreaKey>([
  "Analytes",
  "BlastFiring",
  "BlastHoleDrilling",
  "BlastMaterial",
  "BlastMaterialType",
  "BlastPattern",
  "BlastReference",
  "BucketFactors",
  "BucketTypes",
  "DailyReport",
  "Densities",
  "DeviceMappings",
  "Dewatering",
  "DowntimeSubtypes",
  "DrillBlastSettings",
  "DrillConsumableStock",
  "DrillConsumables",
  "ExplosivesStore",
  "GeologyCrushing",
  "GeologyDrilling",
  "GeologyMilling",
  "GeologyOreBlocks",
  "GeologyOreTally",
  "GeologyRehandle",
  "Locations",
  "Magazines",
  "MaterialTypeClasses",
  "MaterialTypes",
  "Operations",
  "Personnel",
  "PitStages",
  "PlantTypes",
  "Plants",
  "Production",
  "ProductionOreTally",
  "RcDrilling",
  "RecalculateStockpiles",
  "ReportBuilder",
  "ReportLibrary",
  "RoyaltySplits",
  "ShowMiningMvt",
  "StockpileBalances",
  "Stoppages",
  "TargetImport",
  "TargetTypes",
  "Targets",
  "UncheckedGpsStoppages",
  "Zones",
]);
